<template>
    <b-nav pills align="center" class="m-2">
        <b-nav-item v-for="option in options" :key="option.code"
            :active="value === option.code"
            @click="update(option.code)">{{option.description}}</b-nav-item>
    </b-nav>
</template>

<script>
export default {
    props: ["value", "options"],
    methods: {
        update(item) {
            this.$emit('input', item);
        }
    }
}
</script>

<style scoped>
    a:focus {
        outline: none;
    }
</style>